export default {
  forms: [],
  errors: null
};
